"use client";

import { RouteError } from "@/components/RouteError";

/**
 * Next.js App Router root-level error boundary.
 *
 * Catches render-time errors thrown anywhere below the root layout (page,
 * nested layout, etc.) before they reach <GlobalError>. Delegates to the
 * shared <RouteError> so the root boundary looks and behaves identically to
 * every segment error.tsx (badge, humanized message, auto-report) instead of
 * forking its own error UI.
 */
export default function RootError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <RouteError error={error} reset={reset} />;
}
